module.exports = __webpack_public_path__ + "img/Corps Minstrel men 1922.11efb9f4.png";